export const Hamburger = () => (
	<svg
		width="42"
		viewBox="0 0 42 42"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect x="14" y="8.5" width="28" height="3" rx="1.5" fill="#0D75BB" />
		<rect x="14" y="19.5" width="28" height="3" rx="1.5" fill="#0D75BB" />
		<rect x="27" y="30.5" width="15" height="3" rx="1.5" fill="#0D75BB" />
	</svg>
);
export const Facebook = () => (
	<svg
		width="19"
		height="19"
		viewBox="0 0 19 19"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_46_818)">
			<path
				d="M19 9.5C19 4.25329 14.7467 0 9.5 0C4.25329 0 0 4.25329 0 9.5C0 14.2416 3.47399 18.1719 8.01562 18.8846V12.2461H5.60352V9.5H8.01562V7.40703C8.01562 5.02609 9.43395 3.71094 11.6039 3.71094C12.643 3.71094 13.7305 3.89648 13.7305 3.89648V6.23437H12.5326C11.3525 6.23437 10.9844 6.96673 10.9844 7.71875V9.5H13.6191L13.1979 12.2461H10.9844V18.8846C15.526 18.1719 19 14.2416 19 9.5Z"
				fill="currentColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_46_818">
				<rect width="19" height="19" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
export const Instagram = () => (
	<svg
		width="19"
		height="19"
		viewBox="0 0 19 19"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_46_821)">
			<path
				d="M9.5 1.71074C12.0383 1.71074 12.3389 1.72187 13.3371 1.76641C14.2648 1.80723 14.7658 1.96309 15.0998 2.09297C15.5414 2.26367 15.8605 2.47148 16.1908 2.80176C16.5248 3.13574 16.7289 3.45117 16.8996 3.89277C17.0295 4.22676 17.1854 4.73145 17.2262 5.65547C17.2707 6.65742 17.2818 6.95801 17.2818 9.49258C17.2818 12.0309 17.2707 12.3314 17.2262 13.3297C17.1854 14.2574 17.0295 14.7584 16.8996 15.0924C16.7289 15.534 16.5211 15.8531 16.1908 16.1834C15.8568 16.5174 15.5414 16.7215 15.0998 16.8922C14.7658 17.0221 14.2611 17.1779 13.3371 17.2188C12.3352 17.2633 12.0346 17.2744 9.5 17.2744C6.96172 17.2744 6.66113 17.2633 5.66289 17.2188C4.73516 17.1779 4.23418 17.0221 3.9002 16.8922C3.45859 16.7215 3.13945 16.5137 2.80918 16.1834C2.4752 15.8494 2.27109 15.534 2.10039 15.0924C1.97051 14.7584 1.81465 14.2537 1.77383 13.3297C1.7293 12.3277 1.71816 12.0271 1.71816 9.49258C1.71816 6.9543 1.7293 6.65371 1.77383 5.65547C1.81465 4.72773 1.97051 4.22676 2.10039 3.89277C2.27109 3.45117 2.47891 3.13203 2.80918 2.80176C3.14316 2.46777 3.45859 2.26367 3.9002 2.09297C4.23418 1.96309 4.73887 1.80723 5.66289 1.76641C6.66113 1.72187 6.96172 1.71074 9.5 1.71074ZM9.5 0C6.9209 0 6.59805 0.0111328 5.58496 0.0556641C4.57559 0.100195 3.88164 0.263477 3.28047 0.497266C2.65332 0.742188 2.12266 1.06504 1.5957 1.5957C1.06504 2.12266 0.742188 2.65332 0.497266 3.27676C0.263477 3.88164 0.100195 4.57187 0.0556641 5.58125C0.0111328 6.59805 0 6.9209 0 9.5C0 12.0791 0.0111328 12.402 0.0556641 13.415C0.100195 14.4244 0.263477 15.1184 0.497266 15.7195C0.742188 16.3467 1.06504 16.8773 1.5957 17.4043C2.12266 17.9312 2.65332 18.2578 3.27676 18.499C3.88164 18.7328 4.57188 18.8961 5.58125 18.9406C6.59434 18.9852 6.91719 18.9963 9.49629 18.9963C12.0754 18.9963 12.3982 18.9852 13.4113 18.9406C14.4207 18.8961 15.1147 18.7328 15.7158 18.499C16.3393 18.2578 16.8699 17.9312 17.3969 17.4043C17.9238 16.8773 18.2504 16.3467 18.4916 15.7232C18.7254 15.1184 18.8887 14.4281 18.9332 13.4188C18.9777 12.4057 18.9889 12.0828 18.9889 9.50371C18.9889 6.92461 18.9777 6.60176 18.9332 5.58867C18.8887 4.5793 18.7254 3.88535 18.4916 3.28418C18.2578 2.65332 17.935 2.12266 17.4043 1.5957C16.8773 1.06875 16.3467 0.742188 15.7232 0.500977C15.1184 0.267187 14.4281 0.103906 13.4188 0.059375C12.402 0.0111328 12.0791 0 9.5 0Z"
				fill="currentColor"
			/>
			<path
				d="M9.5 4.62012C6.80586 4.62012 4.62012 6.80586 4.62012 9.5C4.62012 12.1941 6.80586 14.3799 9.5 14.3799C12.1941 14.3799 14.3799 12.1941 14.3799 9.5C14.3799 6.80586 12.1941 4.62012 9.5 4.62012ZM9.5 12.6654C7.75215 12.6654 6.33457 11.2479 6.33457 9.5C6.33457 7.75215 7.75215 6.33457 9.5 6.33457C11.2479 6.33457 12.6654 7.75215 12.6654 9.5C12.6654 11.2479 11.2479 12.6654 9.5 12.6654Z"
				fill="currentColor"
			/>
			<path
				d="M15.7121 4.4271C15.7121 5.05796 15.2 5.56636 14.5729 5.56636C13.942 5.56636 13.4336 5.05425 13.4336 4.4271C13.4336 3.79624 13.9457 3.28784 14.5729 3.28784C15.2 3.28784 15.7121 3.79995 15.7121 4.4271Z"
				fill="currentColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_46_821">
				<rect width="19" height="19" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
export const LinkedinIn = () => (
	<svg
		width="19"
		height="19"
		viewBox="0 0 19 19"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_46_826)">
			<path
				d="M17.5974 0H1.40257C1.03059 0 0.673836 0.147771 0.410803 0.410803C0.147771 0.673836 0 1.03059 0 1.40257V17.5974C0 17.9694 0.147771 18.3262 0.410803 18.5892C0.673836 18.8522 1.03059 19 1.40257 19H17.5974C17.9694 19 18.3262 18.8522 18.5892 18.5892C18.8522 18.3262 19 17.9694 19 17.5974V1.40257C19 1.03059 18.8522 0.673836 18.5892 0.410803C18.3262 0.147771 17.9694 0 17.5974 0ZM5.66306 16.1856H2.80646V7.11181H5.66306V16.1856ZM4.23278 5.85438C3.90875 5.85255 3.59252 5.75478 3.324 5.5734C3.05548 5.39203 2.84671 5.13517 2.72403 4.83525C2.60135 4.53534 2.57026 4.2058 2.63469 3.88824C2.69912 3.57067 2.85618 3.2793 3.08604 3.05091C3.3159 2.82252 3.60827 2.66734 3.92624 2.60495C4.24422 2.54256 4.57355 2.57576 4.87267 2.70036C5.17179 2.82497 5.4273 3.03538 5.60695 3.30506C5.7866 3.57474 5.88234 3.89159 5.88208 4.21563C5.88514 4.43257 5.84449 4.64791 5.76255 4.8488C5.68061 5.0497 5.55907 5.23205 5.40516 5.38497C5.25125 5.53789 5.06813 5.65827 4.86671 5.73891C4.66529 5.81956 4.4497 5.85882 4.23278 5.85438ZM16.1922 16.1935H13.3369V11.2364C13.3369 9.77445 12.7155 9.3232 11.9133 9.3232C11.0662 9.3232 10.2349 9.96181 10.2349 11.2733V16.1935H7.37833V7.1184H10.1254V8.37583H10.1624C10.4381 7.81771 11.404 6.86375 12.8778 6.86375C14.4717 6.86375 16.1935 7.80979 16.1935 10.5806L16.1922 16.1935Z"
				fill="currentColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_46_826">
				<rect width="19" height="19" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
export const X = () => (
	<svg
		width="20"
		height="19"
		viewBox="0 0 20 19"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M0.546324 0L7.88201 10.4796L0.5 19H2.16139L8.62433 11.5403L13.8462 19H19.5L11.7516 7.93092L18.6227 0H16.9613L11.0093 6.87026L6.20011 0H0.546324ZM2.98953 1.30752H5.58689L17.0564 17.6923H14.4591L2.98953 1.30752Z"
			fill="currentColor"
		/>
	</svg>
);
export const Youtube = () => (
	<svg
		width="20"
		height="19"
		viewBox="0 0 20 19"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_46_832)">
			<path
				d="M19.1215 4.89688C19.0141 4.49267 18.8024 4.12376 18.5076 3.82707C18.2128 3.53038 17.8453 3.31632 17.4418 3.20632C15.9563 2.80688 10.0188 2.80688 10.0188 2.80688C10.0188 2.80688 4.0813 2.80688 2.59584 3.20632C2.19233 3.31632 1.82478 3.53038 1.52998 3.82707C1.23519 4.12376 1.02349 4.49267 0.916072 4.89688C0.518799 6.38882 0.518799 9.50007 0.518799 9.50007C0.518799 9.50007 0.518799 12.6113 0.916072 14.1032C1.02349 14.5075 1.23519 14.8764 1.52998 15.1731C1.82478 15.4697 2.19233 15.6838 2.59584 15.7938C4.0813 16.1932 10.0188 16.1932 10.0188 16.1932C10.0188 16.1932 15.9563 16.1932 17.4418 15.7938C17.8453 15.6838 18.2128 15.4697 18.5076 15.1731C18.8024 14.8764 19.0141 14.5075 19.1215 14.1032C19.5188 12.6113 19.5188 9.50007 19.5188 9.50007C19.5188 9.50007 19.5188 6.38882 19.1215 4.89688Z"
				fill="currentColor"
			/>
			<path
				d="M8.07568 12.3251V6.6748L13.0416 9.49998L8.07568 12.3251Z"
				fill="white"
			/>
		</g>
		<defs>
			<clipPath id="clip0_46_832">
				<rect
					width="19"
					height="19"
					fill="white"
					transform="translate(0.5)"
				/>
			</clipPath>
		</defs>
	</svg>
);
export const Telegram = () => (
	<svg
		width="21"
		height="19"
		viewBox="0 0 21 19"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M6.51083 11.867C7.88936 11.8672 13.5108 6.73653 14.0108 7.36704C14.5108 7.99756 8.51122 11.867 9.01083 12.8667C9.51043 13.8663 15.0108 17.367 16.5108 17.367C18.0108 17.367 19.4044 3.72754 18.7077 3.04731C18.0109 2.36708 1.01083 9.23665 1.51081 9.8671C2.0108 10.4976 5.13229 11.8669 6.51083 11.867Z"
			fill="currentColor"
		/>
	</svg>
);
export const Discord = () => (
	<svg
		width="19"
		height="19"
		viewBox="0 0 19 19"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_46_783)">
			<path
				d="M16.0843 3.28985C14.8733 2.73419 13.5747 2.32481 12.2169 2.09034C12.1922 2.08581 12.1675 2.09712 12.1548 2.11974C11.9877 2.41679 11.8027 2.80431 11.6732 3.10889C10.2128 2.89026 8.75994 2.89026 7.3295 3.10889C7.19993 2.79754 7.00822 2.41679 6.84046 2.11974C6.82772 2.09788 6.80302 2.08657 6.77829 2.09034C5.42126 2.32406 4.12265 2.73344 2.91091 3.28985C2.90042 3.29437 2.89143 3.30192 2.88546 3.31171C0.422268 6.99166 -0.252502 10.5812 0.0785176 14.1262C0.0800154 14.1435 0.0897511 14.1601 0.103232 14.1706C1.72837 15.3641 3.3026 16.0887 4.8476 16.5689C4.87232 16.5764 4.89852 16.5674 4.91426 16.547C5.27973 16.0479 5.60551 15.5217 5.88484 14.9683C5.90132 14.9359 5.88558 14.8974 5.85189 14.8846C5.33515 14.6886 4.8431 14.4496 4.36979 14.1782C4.33235 14.1563 4.32935 14.1028 4.36379 14.0771C4.46339 14.0025 4.56302 13.9248 4.65813 13.8464C4.67534 13.8321 4.69932 13.8291 4.71955 13.8381C7.82902 15.2578 11.1954 15.2578 14.2682 13.8381C14.2884 13.8283 14.3124 13.8314 14.3303 13.8457C14.4255 13.9241 14.5251 14.0025 14.6254 14.0771C14.6599 14.1028 14.6576 14.1563 14.6202 14.1782C14.1469 14.4549 13.6548 14.6886 13.1373 14.8839C13.1036 14.8967 13.0886 14.9359 13.1051 14.9683C13.3905 15.5209 13.7162 16.0472 14.075 16.5463C14.0899 16.5674 14.1169 16.5764 14.1416 16.5689C15.6941 16.0887 17.2683 15.3641 18.8935 14.1706C18.9077 14.1601 18.9167 14.1443 18.9182 14.1269C19.3144 10.0285 18.2546 6.46844 16.109 3.31246C16.1038 3.30192 16.0948 3.29437 16.0843 3.28985ZM6.34918 11.9676C5.41302 11.9676 4.64165 11.1082 4.64165 10.0526C4.64165 8.99713 5.39806 8.13766 6.34918 8.13766C7.30777 8.13766 8.07168 9.00467 8.0567 10.0526C8.0567 11.1082 7.30028 11.9676 6.34918 11.9676ZM12.6625 11.9676C11.7264 11.9676 10.955 11.1082 10.955 10.0526C10.955 8.99713 11.7114 8.13766 12.6625 8.13766C13.6211 8.13766 14.385 9.00467 14.37 10.0526C14.37 11.1082 13.6211 11.9676 12.6625 11.9676Z"
				fill="#353535"
			/>
		</g>
		<defs>
			<clipPath id="clip0_46_783">
				<rect width="19" height="19" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
export const ClearIcon = () => (
	<svg
		width="37"
		height="37"
		viewBox="0 0 37 37"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M27.75 9.25L9.25 27.75"
			stroke="#00A89D"
			stroke-width="3"
			stroke-linecap="square"
			stroke-linejoin="round"
		/>
		<path
			d="M9.25 9.25L27.75 27.75"
			stroke="#00A89D"
			stroke-width="3"
			stroke-linecap="square"
			stroke-linejoin="round"
		/>
	</svg>
);
export const FaqOpen = () => (
	<svg
		width="26"
		height="25"
		viewBox="0 0 26 25"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_601_12)">
			<path
				d="M17.0002 7L23.8789 13.8787L17.0002 20.7574M2 13.8787H23.9"
				stroke="#00A89D"
				stroke-width="3"
				stroke-linecap="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_601_12">
				<rect
					width="26"
					height="18"
					fill="white"
					transform="translate(0 5)"
				/>
			</clipPath>
		</defs>
	</svg>
);
export const FaqClose = () => (
	<svg
		width="25"
		height="26"
		viewBox="0 0 25 26"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_408_318)">
			<path
				d="M18 17.0002L11.1213 23.8789L4.2426 17.0002M11.1213 2L11.1213 23.9"
				stroke="#00A89D"
				stroke-width="3"
				stroke-linecap="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_408_318">
				<rect
					width="26"
					height="18"
					fill="white"
					transform="translate(20) rotate(90)"
				/>
			</clipPath>
		</defs>
	</svg>
);
export const HeroesVector = () => (
	<svg
		width="175"
		height="23"
		viewBox="0 0 175 23"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M8.56362 14.9448V22.4165H0V0.537842H8.56362V8.00952H21.4263V0.537842H30.0057V22.4165H21.4263V14.9448H8.56362Z"
			fill="#00B0A6"
		/>
		<path
			d="M32.3059 0.569336H58.014V6.1688H40.8695V8.96925H58.014V14.0324H40.8695V16.8328H58.014V22.4494H32.3059V0.570763V0.569336Z"
			fill="#00B0A6"
		/>
		<path
			d="M81.4794 0.553441C86.0068 0.504812 89.8477 4.29786 89.7817 8.8232C89.7817 10.468 89.3409 11.9655 88.4578 13.2999C87.592 14.6186 86.4318 15.6284 84.993 16.2949L89.7817 22.4321H80.6624L76.527 17.093H68.8781V22.4321H60.3145V0.553441H81.4794ZM68.8795 6.95099V10.6782H79.3227C79.8454 10.6782 80.2876 10.4995 80.6466 10.1405C81.0228 9.76574 81.2023 9.32665 81.2023 8.82177C81.2023 7.78054 80.3695 6.94956 79.3227 6.94956H68.8795V6.95099Z"
			fill="#00B0A6"
		/>
		<path
			d="M117.18 0.569336H142.888V6.1688H125.743V8.96925H142.888V14.0324H125.743V16.8328H142.888V22.4494H117.18V0.570763V0.569336Z"
			fill="#00B0A6"
		/>
		<path
			d="M160.274 9.00205C166.402 9.31099 175.014 9.73434 174.999 15.2208C174.999 21.4725 167.808 22.9528 160.094 22.9528C152.396 22.9371 146.007 22.0088 145.19 15.2208H154.163C155.143 16.9142 157.415 17.3533 160.096 17.3533C162.776 17.3533 166.029 16.9142 166.029 15.2208C166.029 14.2597 163.365 14.1138 159.916 13.9508C153.788 13.6418 145.175 13.2185 145.191 7.74914C145.191 1.49748 152.382 0 160.096 0C167.793 0.0486288 174.183 0.911074 175 7.74914H166.027C165.047 6.02425 162.775 5.61663 160.094 5.61663C157.413 5.61663 154.161 6.00709 154.161 7.74914C154.161 8.71028 156.825 8.84043 160.274 9.00205Z"
			fill="#00B0A6"
		/>
		<path
			d="M106.719 11.0043C106.58 10.3822 106.283 9.84582 105.835 9.39243C105.532 9.08635 105.18 8.8475 104.782 8.6773C104.515 8.56288 104.24 8.48136 103.952 8.44417C103.852 8.4313 103.751 8.41985 103.652 8.40698H103.288C103.269 8.41127 103.25 8.41699 103.232 8.41842C103.046 8.4456 102.857 8.45704 102.676 8.50138C101.908 8.69447 101.28 9.10781 100.804 9.73855C100.413 10.2549 100.196 10.8399 100.149 11.4878C100.126 11.811 100.149 12.1285 100.218 12.4432C100.344 13.0081 100.604 13.5073 100.992 13.9378C101.315 14.2968 101.7 14.5728 102.143 14.7659C102.41 14.8818 102.689 14.9647 102.979 15.0019C103.081 15.0148 103.184 15.0277 103.286 15.0405H103.651C103.674 15.0362 103.697 15.0305 103.72 15.0291C103.98 15.0148 104.232 14.9633 104.479 14.8846C105.154 14.6687 105.706 14.2753 106.131 13.7147C106.521 13.1983 106.741 12.6148 106.788 11.9669C106.811 11.6422 106.791 11.3219 106.719 11.0043ZM104.498 14.5342C104.489 14.5256 104.487 14.5242 104.485 14.5213C104.432 14.4355 104.481 14.3726 104.53 14.3054C104.65 14.1409 104.788 13.9836 104.88 13.8019C104.976 13.6117 105.131 13.483 105.268 13.3328C105.322 13.2727 105.373 13.2069 105.416 13.1383C105.482 13.0339 105.446 12.9652 105.321 12.9552C105.225 12.9481 105.127 12.9523 105.029 12.9509C104.973 12.9509 104.917 12.9509 104.857 12.9509C104.894 12.8966 104.85 12.878 104.814 12.8651C104.703 12.8236 104.593 12.775 104.478 12.7521C104.191 12.6935 104.007 12.5175 103.905 12.2558C103.865 12.1528 103.784 12.1471 103.705 12.14C103.525 12.1228 103.441 12.2072 103.446 12.4031C103.45 12.5919 103.504 12.7707 103.568 12.9466C103.595 13.0239 103.628 13.0982 103.655 13.1755C103.68 13.2441 103.718 13.2942 103.784 13.3328C103.906 13.4057 103.96 13.523 103.964 13.6632C103.973 13.8977 103.96 14.1323 104.014 14.364C104.043 14.4884 104.082 14.5485 104.194 14.6286C103.015 14.866 102.007 14.5757 101.213 13.6832C100.525 12.9094 100.333 11.9941 100.564 10.9714C100.663 11.1202 100.749 11.2561 100.844 11.3862C101.017 11.6236 101.188 11.8654 101.378 12.0913C101.588 12.3416 101.876 12.4746 102.186 12.5633C102.476 12.6463 102.736 12.785 102.977 12.9624C103.031 13.001 103.092 13.0324 103.154 13.0553C103.186 13.0668 103.243 13.0696 103.26 13.0496C103.282 13.0253 103.289 12.9724 103.279 12.9366C103.245 12.8022 103.17 12.6878 103.061 12.6005C103.015 12.5633 102.953 12.5347 102.894 12.5261C102.766 12.5061 102.683 12.4317 102.614 12.3345C102.445 12.0971 102.323 11.841 102.336 11.5421C102.343 11.3834 102.386 11.2375 102.518 11.1316C102.597 11.0687 102.677 11.053 102.769 11.0973C102.782 11.1045 102.797 11.1102 102.809 11.1173C102.989 11.206 103.131 11.1545 103.209 10.9671C103.256 10.8513 103.259 10.7326 103.219 10.6139C103.189 10.5223 103.148 10.5109 103.071 10.5681C102.999 10.6225 102.927 10.6782 102.857 10.7326C102.812 10.7669 102.774 10.7497 102.742 10.7154C102.709 10.6782 102.733 10.6453 102.762 10.6153C102.84 10.5323 102.942 10.488 103.045 10.4537C103.206 10.4008 103.371 10.3607 103.533 10.3092C103.612 10.2835 103.691 10.2492 103.761 10.2062C103.836 10.1605 103.84 10.0947 103.79 10.0246C103.733 9.94451 103.671 9.92306 103.579 9.94594C103.404 9.99028 103.237 9.97168 103.084 9.87157C102.99 9.8115 102.943 9.81579 102.855 9.88301C102.792 9.93164 102.758 9.93021 102.71 9.86442C102.647 9.77574 102.593 9.67991 102.529 9.58981C102.425 9.44249 102.268 9.38671 102.097 9.38099C101.948 9.37527 101.799 9.38814 101.651 9.39243C101.639 9.39243 101.628 9.39243 101.609 9.39243C102.676 8.48994 104.619 8.41556 105.796 9.84582C105.707 9.86299 105.618 9.87443 105.532 9.89874C105.351 9.95023 105.166 10.0146 105.077 10.1905C104.975 10.3936 104.813 10.5438 104.672 10.714C104.593 10.8084 104.514 10.9014 104.474 11.0215C104.415 11.1974 104.455 11.3562 104.564 11.4992C104.632 11.5879 104.718 11.6551 104.82 11.7023C104.871 11.7266 104.92 11.7238 104.975 11.7037C105.044 11.678 105.118 11.6494 105.19 11.6522C105.308 11.6551 105.37 11.7481 105.413 11.8439C105.496 12.027 105.53 12.2229 105.561 12.4203C105.594 12.6406 105.627 12.8622 105.663 13.0825C105.67 13.1297 105.68 13.1841 105.737 13.1998C105.802 13.2169 105.843 13.174 105.882 13.134C105.984 13.0296 106.027 12.898 106.053 12.7593C106.063 12.7092 106.073 12.6563 106.067 12.6062C106.057 12.5118 106.099 12.4417 106.154 12.3731C106.256 12.2429 106.358 12.1114 106.458 11.9826C106.3 13.2112 105.641 14.0579 104.494 14.5356L104.498 14.5342Z"
			fill="#00B0A6"
			stroke="#00B0A6"
			stroke-width="1.25"
			stroke-miterlimit="10"
		/>
		<path
			d="M111.979 1.81931C111.82 1.53898 111.554 1.4217 111.244 1.41598C110.883 1.40883 110.523 1.41598 110.164 1.42456C109.713 1.436 109.38 1.87652 109.387 2.277C109.387 2.30846 109.387 2.33993 109.387 2.38141C109.054 2.19547 108.735 2.01097 108.409 1.83791C107.565 1.38881 106.688 1.00979 105.766 0.750911C105.253 0.606454 104.729 0.497756 104.206 0.394777C103.888 0.333276 103.562 0.317542 103.239 0.277495C103.17 0.268914 103.104 0.241738 103.036 0.223145H101.829C101.665 0.25175 101.501 0.276064 101.339 0.307529C100.905 0.390484 100.47 0.463426 100.04 0.560684C99.3905 0.70657 98.7587 0.915389 98.1513 1.18285C97.5425 1.45031 96.9438 1.74494 96.3565 2.05674C95.9257 2.28558 95.5107 2.54875 95.1058 2.82336C94.7655 3.05363 94.4468 3.31966 94.1251 3.57567C93.7877 3.84456 93.4905 4.1535 93.2636 4.5225C93.1961 4.63263 93.1473 4.75278 93.0898 4.86863V5.26052C93.0985 5.27053 93.1143 5.27911 93.1143 5.28913C93.1817 5.8269 93.6125 6.13298 94.0921 6.18017C94.6076 6.23166 95.0785 6.07863 95.4978 5.78256C95.7003 5.63954 95.8755 5.46075 96.0779 5.31773C96.6192 4.93728 97.2338 4.70272 97.8584 4.51106C98.5189 4.30797 99.1924 4.14349 99.8629 3.97758C100.172 3.90177 100.489 3.85171 100.805 3.80737C101.16 3.75875 101.516 3.72013 101.872 3.69581C102.311 3.66578 102.752 3.64862 103.191 3.64004C103.382 3.63575 103.51 3.75016 103.562 3.92179C103.603 4.0591 103.539 4.16208 103.433 4.2293C103.359 4.27507 103.265 4.30225 103.177 4.30511C102.739 4.32084 102.301 4.31512 101.863 4.34086C101.493 4.36089 101.122 4.3995 100.755 4.45385C100.39 4.50963 100.028 4.58972 99.6691 4.67268C99.0904 4.80712 98.5089 4.93442 97.9374 5.09747C97.4061 5.24907 97.1189 5.71963 97.1965 6.24311C97.2568 6.65359 97.5626 6.94393 97.9489 7.04262C98.3998 7.15704 98.8678 7.19423 99.3374 7.16705C99.8385 7.13702 100.34 7.12844 100.841 7.10984C101.096 7.09983 101.35 7.08839 101.606 7.07981C101.903 7.0698 102.203 7.03833 102.498 7.06265C102.884 7.09411 103.242 7.24715 103.596 7.40019C103.958 7.55608 104.333 7.70626 104.726 7.71628C105.255 7.73058 105.785 7.70197 106.313 7.66335C106.722 7.63332 107.13 7.56467 107.536 7.49887C107.904 7.4388 108.269 7.36014 108.635 7.2872C108.882 7.23714 109.129 7.18136 109.371 7.12844C109.389 7.25001 109.391 7.35585 109.419 7.45597C109.526 7.84071 109.799 8.07813 110.145 8.10673C110.526 8.1382 110.912 8.1239 111.295 8.10817C111.685 8.09243 111.963 7.83499 112.085 7.49172C112.101 7.44739 112.121 7.40591 112.14 7.36157V2.2112C112.087 2.07962 112.049 1.94089 111.979 1.81931Z"
			fill="#00B0A6"
		/>
		<path
			d="M93.2477 21.4038C93.4071 21.6841 93.6728 21.8014 93.9829 21.8071C94.3433 21.8143 94.7037 21.8071 95.0627 21.7986C95.5136 21.7871 95.8467 21.3466 95.8395 20.9461C95.8395 20.9147 95.8395 20.8832 95.8395 20.8417C96.1726 21.0277 96.4914 21.2122 96.8173 21.3852C97.6617 21.8343 98.539 22.2133 99.4608 22.4722C99.9734 22.6167 100.498 22.7254 101.02 22.8283C101.339 22.8898 101.665 22.9056 101.988 22.9456C102.057 22.9542 102.123 22.9814 102.19 23H103.398C103.562 22.9714 103.725 22.9471 103.888 22.9156C104.321 22.8326 104.756 22.7597 105.187 22.6624C105.836 22.5166 106.468 22.3077 107.075 22.0403C107.684 21.7728 108.283 21.4782 108.87 21.1664C109.301 20.9375 109.716 20.6744 110.121 20.3998C110.461 20.1695 110.78 19.9035 111.102 19.6474C111.439 19.3786 111.736 19.0696 111.963 18.7006C112.031 18.5905 112.079 18.4703 112.137 18.3545V17.9626C112.128 17.9526 112.112 17.944 112.112 17.934C112.045 17.3962 111.614 17.0901 111.135 17.0429C110.619 16.9915 110.148 17.1445 109.729 17.4406C109.526 17.5836 109.351 17.7624 109.149 17.9054C108.607 18.2858 107.993 18.5204 107.368 18.7121C106.708 18.9152 106.034 19.0796 105.364 19.2455C105.055 19.3213 104.738 19.3714 104.422 19.4157C104.067 19.4644 103.711 19.503 103.355 19.5273C102.916 19.5573 102.475 19.5745 102.035 19.5831C101.844 19.5874 101.717 19.473 101.665 19.3013C101.623 19.164 101.688 19.061 101.794 18.9938C101.867 18.9481 101.962 18.9209 102.05 18.918C102.488 18.9023 102.926 18.908 103.364 18.8823C103.734 18.8622 104.104 18.8236 104.472 18.7693C104.837 18.7135 105.199 18.6334 105.558 18.5504C106.136 18.416 106.718 18.2887 107.289 18.1257C107.821 17.974 108.108 17.5035 108.03 16.98C107.97 16.5695 107.664 16.2792 107.278 16.1805C106.827 16.0661 106.359 16.0289 105.889 16.0561C105.388 16.0861 104.887 16.0947 104.386 16.1133C104.13 16.1233 103.876 16.1347 103.621 16.1433C103.323 16.1533 103.023 16.1848 102.729 16.1605C102.343 16.129 101.985 15.976 101.63 15.8229C101.269 15.667 100.894 15.5169 100.5 15.5068C99.972 15.4925 99.4421 15.5212 98.9137 15.5598C98.5045 15.5898 98.0967 15.6585 97.6904 15.7242C97.3228 15.7843 96.9581 15.863 96.5919 15.9359C96.3449 15.986 96.098 16.0418 95.8553 16.0947C95.8381 15.9731 95.8352 15.8673 95.8079 15.7672C95.7002 15.3824 95.4274 15.145 95.0814 15.1164C94.7009 15.0849 94.3146 15.0992 93.9312 15.115C93.5421 15.1307 93.2635 15.3881 93.1415 15.7314C93.1257 15.7757 93.1056 15.8172 93.0869 15.8616V21.0119C93.14 21.1435 93.1774 21.2822 93.2477 21.4038Z"
			fill="#00B0A6"
		/>
	</svg>
);
export const PrevSlideIcon = () => (
	<svg
		width="26"
		height="18"
		viewBox="0 0 26 18"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_601_131)">
			<path
				d="M8.9998 16L2.1211 9.12132L8.9998 2.2426M24 9.12132L2.1 9.12132"
				stroke="#00A89D"
				stroke-width="3"
				stroke-linecap="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_601_131">
				<rect
					width="26"
					height="18"
					fill="white"
					transform="translate(26 18) rotate(-180)"
				/>
			</clipPath>
		</defs>
	</svg>
);
export const NextSlideIcon = () => (
	<svg
		width="26"
		height="19"
		viewBox="0 0 26 19"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_601_129)">
			<path
				d="M17.0002 2.34009L23.8789 9.21877L17.0002 16.0975M2 9.21877H23.9"
				stroke="#00A89D"
				stroke-width="3"
				stroke-linecap="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_601_129">
				<rect
					width="26"
					height="18"
					fill="white"
					transform="translate(0 0.340088)"
				/>
			</clipPath>
		</defs>
	</svg>
);
